import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import de from './locales/de.json';
import en from './locales/en.json';

const savedLng = typeof window !== 'undefined' ? localStorage.getItem('i18n_lng') : null;

i18n.use(initReactI18next).init({
  lng: savedLng === 'en' ? 'en' : 'de',
  fallbackLng: 'de',
  resources: {
    de: { translation: de as Record<string, unknown> },
    en: { translation: en as Record<string, unknown> },
  },
  interpolation: { escapeValue: false },
});

i18n.on('languageChanged', (lng) => {
  if (typeof window !== 'undefined') localStorage.setItem('i18n_lng', lng);
});
